import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import InputField from '../../../components/form/InputField';
import TextEditor from '../../../components/form/TextEditor';
import SubmitButton from '../../../components/form/SubmitButton';
import LoadingButton from '../../../components/form/LoadingButton';
import { useUpdateResource } from '../../../hooks/useUpdateResource';
import { PagesType } from '../../../types/enum/pagesType';
import { usePagesContentAdmin } from '../../../hooks/admin/pages.admin';
import LoadingErrorState from '../../../components/ui/LoadingErrorState';

type Props = {
  keyType: PagesType;
};

export interface PageFormData {
  languages: {
    languageCode: 'en' | 'ar';
    title: string;
    content: string;
  }[];
}

export default function SiteContentForm({ keyType }: Props) {
    const {data,isLoading , isError} = usePagesContentAdmin(keyType);

    console.log({keyType,data})


  const { t } = useTranslation();
  const { register, handleSubmit, setValue, watch } = useForm<PageFormData>({
    defaultValues: {
      languages: [
        { languageCode: 'en', title: '', content: '' },
        { languageCode: 'ar', title: '', content: '' },
      ],
    },
  });

   useEffect(()=>{
        if(data){
            setValue("languages",data.languages.map(da=>({languageCode:da.languageCode,content:da.content,title:da.title})));;
        }
    },[setValue,data,keyType])

  const { loading, updateResource } = useUpdateResource();

  const onSubmit = (data: PageFormData) => {
    updateResource(
      `page`,
      { type:keyType, contents:data.languages },
      'admin',
      {
        method: 'POST',
        successMessage: t("updatedSuccess"),
        invalidateQueries: ['pages-by-admin'],
      }
    );
  };

  const handleEditorContent = (lang: 'en' | 'ar', content: string) => {
    const index = lang === 'en' ? 0 : 1;
    setValue(`languages.${index}.content`, content);
  };

  return (
    <div>
        <LoadingErrorState
        isError={isError}
        isLoading={isLoading}
        />
         {
            (data && !isLoading) &&
            <form key={keyType} onSubmit={handleSubmit(onSubmit)} className="space-y-10">

                {/* Arabic Section */}
            <div className="p-4 border rounded-2xl">
                <h3 className="font-bold text-lg mb-4">{t('arabicSectionTitle')}</h3>

                <InputField
                label={t("title_ar")}
                placeholder={t('titlePlaceholder')}
                register={register('languages.1.title', { required:t("required_field") })}
                />

                <div className="mt-4">
                <label className="block text-sm font-semibold text-muted mb-2">
                    {t('content_ar')}
                </label>
                <TextEditor
                  key={watch('languages.1.content')+keyType} // اجعل المفتاح المحتوى نفسه
                    onSendEditorContent={(content) => handleEditorContent("ar", content)}
                    initialValue={data.languages.find(da=>da.languageCode==="ar")?.content}
                />
                </div>
            </div>

            {/* English Section */}
            <div className="p-4 border rounded-2xl">
                <h3 className="font-bold text-lg mb-4">{t('englishSectionTitle')} </h3>

                <InputField
                label={t("title_en")}
                placeholder={t('titlePlaceholder')}
                register={register('languages.0.title', { required: t("required_field") })}
                />

                <div className="mt-4">
                <label className="block text-sm font-semibold text-muted mb-2">
                    {t('content_en')}
                </label>
                <TextEditor
                     key={watch('languages.0.content')+keyType} // اجعل المفتاح المحتوى نفسه
                    onSendEditorContent={(content) => handleEditorContent('en', content)}
                    initialValue={data.languages.find(da=>da.languageCode==="en")?.content}
                />
                </div>
            </div>


            {/* Submit */}
            <div className="flex justify-end">
                {loading ? <LoadingButton /> : <SubmitButton label={t('update')} />}
            </div>
        </form>
         }
    </div>
  );
}
